import { initializeErrorTracking } from "@error-tracking/client";

function startErrorTracking(): void {
  if (
    import.meta.env.MODE !== "production" ||
    import.meta.env.VITE_LOCAL === "true"
  ) {
    return;
  }

  initializeErrorTracking({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID as string,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string,
    service: import.meta.env.VITE_DATADOG_SERVICE as string,
    version: import.meta.env.VITE_APP_VERSION as string,
    mode: import.meta.env.MODE,
    trackUserInteractions: false,
  });
}

export { startErrorTracking };
